module.exports = __webpack_public_path__ + "img/logo_fox--footer@3x.3ddf4d10.png";